import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createWatchlistEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackWatchlistOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.WATCHLIST_OPEN,
      properties: { source },
    });

  const trackWatchlistCreate = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.WATCHLIST_CREATE,
      properties: { source },
    });

  const trackWatchlistTabSelected = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.WATCHLIST_TAB_SELECTED,
      properties: { source, type },
    });

  return {
    trackWatchlistOpen,
    trackWatchlistCreate,
    trackWatchlistTabSelected,
  };
};
